"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationTypes = exports.getErrorMessage = exports.TicketSubmissionDTO = exports.TicketSubmissionDrawDTO = exports.TicketSubmissionPrizeDTOList = exports.TicketSubmissionPrizeDTO = exports.Types = void 0;
var TicketSubmissionDrawDTO_1 = require("./TicketSubmissionDrawDTO");
Object.defineProperty(exports, "TicketSubmissionDrawDTO", { enumerable: true, get: function () { return TicketSubmissionDrawDTO_1.TicketSubmissionDrawDTO; } });
var TicketSubmissionDTO_1 = require("./TicketSubmissionDTO");
Object.defineProperty(exports, "TicketSubmissionDTO", { enumerable: true, get: function () { return TicketSubmissionDTO_1.TicketSubmissionDTO; } });
var TicketSubmissionPrizeDTO_1 = require("./TicketSubmissionPrizeDTO");
Object.defineProperty(exports, "TicketSubmissionPrizeDTO", { enumerable: true, get: function () { return TicketSubmissionPrizeDTO_1.TicketSubmissionPrizeDTO; } });
var TicketSubmissionPrizeDTOList_1 = require("./TicketSubmissionPrizeDTOList");
Object.defineProperty(exports, "TicketSubmissionPrizeDTOList", { enumerable: true, get: function () { return TicketSubmissionPrizeDTOList_1.TicketSubmissionPrizeDTOList; } });
var Types = __importStar(require("./types"));
exports.Types = Types;
var utils_1 = require("./utils");
Object.defineProperty(exports, "getErrorMessage", { enumerable: true, get: function () { return utils_1.getErrorMessage; } });
var validationTypes = __importStar(require("./validationTypes"));
exports.validationTypes = validationTypes;
//# sourceMappingURL=index.js.map